<script>
import OSMSource from 'ol/source/OSM'
import xyzSource from '../mixins/layers/xyz-source'
const OSM_ATTRIBUTIONS = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.'
const OSM_URL_TEMPLATE = 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
const OSM_MAX_ZOOM = 19

const props = {
	attributions: {
		type: [String, Array],
		default: OSM_ATTRIBUTIONS,
	},
	maxZoom: {
		type: Number,
		default: OSM_MAX_ZOOM,
	},
	url: {
		type: String,
		default: OSM_URL_TEMPLATE,
	},
}

const methods = {
	createSource () {
		// console.log("createOlObject OSMLayer.vue")
		// console.log(this)
		// always EPSG:3857, size: 256x256, format png
		return new OSMSource({
			url: this.urlTmpl,
			attributions: this.attributions,
			crossOrigin: this.crossOrigin,
			maxZoom: this.maxZoom,
			cacheSize: this.cacheSize,
			opaque: this.opaque,
			reprojectionErrorThreshold: this.reprojectionErrorThreshold,
			wrapX: this.wrapX,
			transition: this.transition
		})
	},
}
export default {
	name: 'tile-source',
	mixins: [xyzSource],
	props,
	methods,
}
</script>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Layers/TileSource.vue